export default {"blurContainer":"S-KjQ","blurBox":"lWsE5","blurContent":"-McM9","body":"qtJFk","desktop":"_-1QAa","mobile":"_8NMuh","text":"UVjSK"};